import React, { useRef, useState } from "react";
import { Button, Dropdown, Input } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useBackend } from "backend/useBackend";

const getSearchableColumns = (columns) => {
  const searchableColumns = columns.filter((c) => c.searchable === true);
  if (searchableColumns.length > 0) {
    return searchableColumns;
  }
  return [];
};

const setDefaultSearchKey = (columns) => {
  if (getSearchableColumns(columns).length > 0) {
    return getSearchableColumns(columns)[0].key;
  }
  return ''
};
const SearchBy = ({
  endpoint,
  columns,
  setResult,
  otherConditions = {},
  placeholder = "Filter...",
}) => {
  // return null;
  const searchRef = useRef(null);
  const { searchItems } = useBackend();
  const [searchBy, setSearchBy] = useState(setDefaultSearchKey(columns));

  const handleSearch = (s) => {
    if (searchRef) {
      const el = searchRef.current;
      el.value = "";
      el.focus();
      setSearchBy(s);
      setResult([], 0);
    }
  };

  const search = async (e) => {
    const searchValue = String(e.target.value);
    if (searchValue.length > 1) {
      searchItems(endpoint, searchBy, searchValue, otherConditions)
        .then((items) => {
          // console.log("items", items);
          setResult(items, searchValue.length);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setResult([], searchValue.length);
    }
  };

  const items = getSearchableColumns(columns).map((option) => ({
    key: option.key,
    label: option.title,
    onClick: () => handleSearch(option.key),
  }));

  return items.length > 0 ? (
    <Input.Group compact>
      <Input
        ref={searchRef}
        style={{ width: "50%" }}
        placeholder={placeholder}
        onChange={search}
      />
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Button type="primary" onClick={(e) => e.preventDefault()}>
          By {columns.find((s) => searchBy === s.key)["title"]} <DownOutlined />
        </Button>
      </Dropdown>
    </Input.Group>
  ) : null;
};

export default SearchBy;
